class Popup {
  constructor(texts) {
    this.texts = texts;
    this.$popup = $('<div class="info-box-popup"></div>');
    this.init();
  }

  init() {
    if (!$('.w-iconbox').length) return;

    $('.w-hwrapper.wrap').append(this.$popup);

    $('.w-iconbox').on('click mouseenter', (e) => this.showPopup(e));
    $('.w-iconbox').on('mouseleave', () => this.hidePopup());
    this.$popup.on('click', () => this.hidePopup());
  }

  showPopup(e) {
    e.preventDefault();
    var id = $(e.currentTarget).attr('id');
    this.$popup.stop(true, true).text(this.texts[`#${id}`]).fadeIn(300);
  }

  hidePopup() {
    this.$popup.stop(true, true).fadeOut(300);
  }
}

export default Popup;

